import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Spinner } from '@openedx/paragon';

export default class PageLoading extends Component {
  renderSrMessage() {
    if (!this.props.srMessage) {
      return null;
    }

    return (
      <span className="sr-only">
        {this.props.srMessage}
      </span>
    );
  }

  render() {
    const {
      applyMinHeight = true,
      className,
    } = this.props;

    return (
      <div>
        <div
          className={classNames(
            'd-flex justify-content-center align-items-center flex-column',
            { [className]: !!className },
          )}
          style={{
            ...(applyMinHeight && { height: '50vh' }),
          }}
        >
          <Spinner animation="border" variant="primary" screenReaderText={this.renderSrMessage()} />
        </div>
      </div>
    );
  }
}

PageLoading.propTypes = {
  srMessage: PropTypes.node.isRequired,
  className: PropTypes.string,
  applyMinHeight: PropTypes.bool,
};
